import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { appInitializerProvider } from './app/core/app-initializer/app-initializer.service';
import { ENVIRONMENT } from './app/core/models/environment.token';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { loadingInterceptor } from './app/shared/loading/loading.interceptor';
import { decompressInterceptor } from './app/shared/decompress/decompress.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule),
    appInitializerProvider,
    ...environment.providers,
    { provide: ENVIRONMENT, useValue: environment },
    provideHttpClient(withInterceptors([loadingInterceptor, decompressInterceptor])),
  ],
}).catch(err => console.error(err));
